import * as React from 'react';
import ReactDOM from 'react-dom';

import { FlameTheme } from '@lightspeed/flame/Core';

import AlertMessageDisplay, {
  AlertMessageDTO,
} from 'root/apps/components/AlertMessageDisplay/AlertMessageDisplay';
import { REQUEST_QUEUE_AJAX_MESSAGES_EVENT } from 'root/merchantos/server_call';

export enum PurchaseMessageMetadataKey {
  costsFailedMsg = 'purchase_costs_failed_msg',
  costsSuccessMsg = 'purchase_costs_success_msg',
}

interface AjaxMessagesHandlerProps {
  ajaxMessagesDisplay: HTMLDivElement;
}

const AjaxMessagesHandler: React.FC<AjaxMessagesHandlerProps> = ({ ajaxMessagesDisplay }) => {
  const [ajaxMessages, setAjaxMessages] = React.useState<AjaxMessages | undefined>({});
  const [alertMessage, setAlertMessage] = React.useState<AlertMessageDTO | null>(null);

  const handleOnClose = () => {
    ajaxMessagesDisplay.classList.add('hidden');
    setAlertMessage(null);
  };

  React.useEffect(() => {
    const findPurchasesAjaxMessages = (
      ajaxMessagesCollection: AjaxMessages[]
    ): AjaxMessages | undefined => {
      return ajaxMessagesCollection.find((ajaxMessages) => {
        if (ajaxMessages && ajaxMessages.metadata) {
          if (
            ajaxMessages.metadata[PurchaseMessageMetadataKey.costsFailedMsg] ||
            ajaxMessages.metadata[PurchaseMessageMetadataKey.costsSuccessMsg]
          ) {
            return true;
          }
        }
        return false;
      });
    };

    const updateAjaxMessages = (event: Event) => {
      if (event instanceof CustomEvent) {
        setAjaxMessages(findPurchasesAjaxMessages(event.detail));
      }
    };
    window.addEventListener(REQUEST_QUEUE_AJAX_MESSAGES_EVENT, updateAjaxMessages);
    return () => {
      window.removeEventListener(REQUEST_QUEUE_AJAX_MESSAGES_EVENT, updateAjaxMessages);
    };
  }, []);

  React.useEffect(() => {
    let alertMessageDTO: AlertMessageDTO | null = null;

    if (ajaxMessages && ajaxMessages.metadata) {
      const keys: Array<PurchaseMessageMetadataKey | string> = Object.keys(ajaxMessages.metadata);

      if (keys.includes(PurchaseMessageMetadataKey.costsFailedMsg)) {
        alertMessageDTO = {
          type: 'danger',
          message: ajaxMessages.metadata[PurchaseMessageMetadataKey.costsFailedMsg],
        };
      } else if (keys.includes(PurchaseMessageMetadataKey.costsSuccessMsg)) {
        alertMessageDTO = {
          type: 'success',
          message: ajaxMessages.metadata[PurchaseMessageMetadataKey.costsSuccessMsg],
        };
      }
    }

    setAlertMessage(alertMessageDTO);
  }, [ajaxMessagesDisplay, ajaxMessages]);

  if (alertMessage) {
    ajaxMessagesDisplay.style.height = 'auto';
    ajaxMessagesDisplay.style.padding = '6px';
    ajaxMessagesDisplay.classList.remove('hidden');
    return ReactDOM.createPortal(
      <FlameTheme>
        <AlertMessageDisplay alertMessage={alertMessage} onClose={handleOnClose} />
      </FlameTheme>,
      ajaxMessagesDisplay
    );
  }

  return null;
};

export default AjaxMessagesHandler;
